<template>
  <div v-if="medium.type === 'Vr'" class="vr-wrap row" v-html="medium.script"></div>
  <div v-else-if="medium.type === 'Video'" class="first-video-wrap row">
    <iframe
      class="embed-video"
      :src="videoUrl"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
    ></iframe>
  </div>
  <div v-else-if="medium.type === 'Photo'" class="first-photo-wrap row">
    <img :src="mainPhoto" alt="" />
  </div>
</template>

<script>
export default {
  props: ['medium'],
  computed: {
    mainPhoto() {
      return `${this.medium.src}/l.jpeg`;
    },
    videoUrl() {
      return `https://www.youtube.com/embed/${this.medium.youtubeMrId}`;
    },
  }
};
</script>

<style scoped>
.first-photo-wrap {
  background: black;
  text-align: center;
}

.first-photo-wrap img {
  max-height: 658px;
}

.first-video-wrap {
  display: flex;
}

.vr-wrap {
  display: flex;
}

.vr-wrap >>> iframe {
  width: 100%;
  aspect-ratio: 16 / 9;
}

.embed-video {
  width: 100%;
  aspect-ratio: 16 / 9;
}
@media (max-width: 812px) {
  .vr-wrap >>> iframe {
    height: calc(100vh - 240px);
  }

  .first-photo-wrap img {
    max-height: none;
    width: 100%;
  }
}

@media screen and (min-width: 813px) and (max-width: 991px) {
  .first-photo-wrap img {
    max-height: 421px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .first-photo-wrap img {
    max-height: 545px;
  }
}
</style>
